import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { BaseViewComponent } from '@sb/library/base';
import { StepperComponent } from '../stepper.component';

@Component({
    selector: 'lib-step',
    templateUrl: './step.component.html',
    styleUrl: './step.component.scss'
})
export class StepComponent<T> extends BaseViewComponent {

    @Input({required: true}) name!: T;
    @Input() qaTag: string = '';

    @ViewChild('content', {static: true, read: TemplateRef}) content!: TemplateRef<any>;

    set stepper(value: StepperComponent<any>) {
        const values = Object.values(value.type);
        if (!values.includes(this.name)) {
            throw Error(`You have passed in a name, ${this.name} that does not exist in the StepperComponent`);
        }
    }

}
